import { type PhoneNumbersTranslateFn, text } from '../types/i18n.types'

/**
 * Canonical phone number `type` values — must match mango-api
 * `PhoneNumber.Type` (`project/app/models/phone_number.py`) and legacy-admin
 * `phone_numbers.type`.
 */
export type PhoneNumberTypeValue =
  'caller_id' | 'sms_only' | 'standard' | 'temporary'

export const PHONE_NUMBER_TYPE_OPTIONS: ReadonlyArray<{
  value: PhoneNumberTypeValue
  labelKey: string
  fallbackLabel: string
}> = [
  {
    value: 'caller_id',
    labelKey: 'phoneNumbers.types.callerId',
    fallbackLabel: 'Caller ID',
  },
  {
    value: 'sms_only',
    labelKey: 'phoneNumbers.types.smsOnly',
    fallbackLabel: 'SMS Only',
  },
  {
    value: 'standard',
    labelKey: 'phoneNumbers.types.standard',
    fallbackLabel: 'Standard',
  },
  {
    value: 'temporary',
    labelKey: 'phoneNumbers.types.temporary',
    fallbackLabel: 'Temporary',
  },
]

/** Labels for mistaken / legacy values previously used in this UI (not valid API enums). */
const LEGACY_TYPE_LABELS: Record<string, string> = {
  fax: 'Fax',
  efax: 'eFax',
  sms: 'SMS',
}

export function getPhoneNumberTypeLabel(
  type: string | null | undefined,
  t?: PhoneNumbersTranslateFn,
): string {
  if (!type) {
    return '—'
  }
  const known = PHONE_NUMBER_TYPE_OPTIONS.find((o) => o.value === type)
  if (known) {
    return text(t, known.labelKey, known.fallbackLabel)
  }
  return LEGACY_TYPE_LABELS[type] ?? type
}

export function getPhoneNumberTypeSelectOptions(
  t?: PhoneNumbersTranslateFn,
): Array<{ value: PhoneNumberTypeValue; label: string }> {
  return PHONE_NUMBER_TYPE_OPTIONS.map((o) => ({
    value: o.value,
    label: text(t, o.labelKey, o.fallbackLabel),
  }))
}
